(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["button"] && !Shopify.designMode) return;
  try {
    class HoneButton extends HTMLElement {
    constructor() {
      super();
      this.linkElement = this.querySelector('a, button');
    }

    connectedCallback() {
      if (this.linkElement) {
        const canonSpan = this.linkElement.querySelector('span.hone-button__link-inner');
        const hoverSpan = canonSpan.cloneNode(true);
        hoverSpan.setAttribute('aria-hidden', 'true');
        hoverSpan.classList.remove('inline-flex');
        hoverSpan.classList.add(
          'absolute',
          'inset-0',
          'flex',
          'items-center',
          'justify-center',
          'transition-transform',
          'transform',
          'translate-y-full',
          'duration-500',
          'pointer-events-none',
        );
        this.linkElement.appendChild(hoverSpan);

        let buttonHeight = Math.max(this.offsetHeight, 32);
        this.style.setProperty('--hone-button-height', `${buttonHeight}px`);
        canonSpan.classList.add('relative', 'z-10', 'transition-transform', 'transform', 'duration-500');
        if (this.linkElement.classList.contains('uses-group-hover')) {
          hoverSpan.classList.add('group-hover:translate-y-0');
          canonSpan.classList.add('group-hover:-translate-y-[var(--hone-button-height)]');
        } else {
          hoverSpan.classList.add('group-hover/button:translate-y-0');
          canonSpan.classList.add('group-hover/button:-translate-y-[var(--hone-button-height)]');
        }
      }
    }
  }
  customElements.define('hone-button', HoneButton);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["split-header-section"] && !Shopify.designMode) return;
  try {
    class HoneSplitSection extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const button = this.querySelector('hone-button a');
      if (button !== null) {
        this.addEventListener('click', () => {
          button.click();
        });
      }
    }
  }

  customElements.define('hone-split-section', HoneSplitSection);
  } catch(e) { console.error(e); }
})();

})();
